// extracted by mini-css-extract-plugin
export default {"openBtn":"style_openBtn__HbDlr","img":"style_img__vCGVw","htmlInner":"style_htmlInner__L-sWA","htmlText":"style_htmlText__Aq8hL"};